<script lang="ts">
	import { createTableOfContents, melt } from '@melt-ui/svelte';
	import { ChevronDown, ChevronUp } from 'lucide-svelte';

	const {
		elements: { item },
		states: { headingsTree }
	} = createTableOfContents({
		selector: '#toc-builder-content',
		exclude: ['h1', 'h3', 'h4', 'h5', 'h6'],
		headingFilterFn: (heading) => !heading.hasAttribute('data-toc-ignore'),
		scrollOffset: 120,
		activeType: 'highest',
		rootMargin: '-120px 0px 0px'
	});

	let expanded = $state(false);
</script>

<div class="section-mb w-full rounded-2xl bg-[#F5F2EA] p-5">
	<header class="body-bold divide-gray-light mb-5 divide-x">
		<header class="text-center">In this article</header>
	</header>
	<nav
		class="data-[expandable]:pb-0"
		data-expandable={$headingsTree?.length > 3 ? true : undefined}
	>
		{#key $headingsTree}
			<ul class="m-0 list-none">
				{#if $headingsTree?.length}
					{#each $headingsTree.slice(0, expanded ? undefined : 3) as heading, i (i)}
						<li class="[&:not(:first-child)]:pt-4">
							<a
								href="#{heading.id}"
								use:melt={$item(heading.id)}
								class="hover:!text-green-primary data-[active]:text-green-primary inline-flex items-center justify-center gap-1
						 text-black no-underline transition-colors hover:opacity-75"
							>
								{heading.title}
							</a>
						</li>
					{/each}
					{#if $headingsTree.length > 3}
						<button
							onclick={() => (expanded = !expanded)}
							class="index-bold text-gray-dark mt-5 flex w-full items-center justify-center"
						>
							{#if expanded}
								See Less
								<ChevronUp class="h-6 w-6" />
							{:else}
								See More
								<ChevronDown class="h-6 w-6" />
							{/if}
						</button>
					{/if}
				{/if}
			</ul>
		{/key}
	</nav>
</div>
